export default {
    name: "UpdateData",
    title: "Update Data",
    icon: "mdi-database-edit",
    create() {
        return {
            name: this.title,
            description: null,
            actionType: this.name,
            table: null,
            idValue: null,
            values: [],
            childAction1: [],
            childAction2: []
        };
    },
};